// extracted by mini-css-extract-plugin
export var banner = "_j7-0";
export var closeButton = "_j7-2";
export var greenCheckmark = "_j7-3";
export var hereLink = "_j7-4";
export var titleIcon = "_j7-1";